import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '../../dialogs/dialogs.module';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CdDateTimePickerComponent } from './cd-date-time-picker.component';
import { CdDateTimePickerOverlayDialogComponent } from './cd-date-time-picker-overlay-dialog.component';
import { CdDateTimePickerInputComponent } from './cd-date-time-picker-input.component';
import { CommonPipesModule } from '../../pipes/common-pipes.module';
import { CommonDirectivesModule } from '../../directives/common-directives.module';

@NgModule({
  imports: [CommonModule, DialogModule, FormsModule, TranslateModule.forChild(), CommonPipesModule, CommonDirectivesModule],
  declarations: [CdDateTimePickerComponent, CdDateTimePickerOverlayDialogComponent, CdDateTimePickerInputComponent],
  entryComponents: [CdDateTimePickerOverlayDialogComponent],
  exports: [CdDateTimePickerComponent, CdDateTimePickerInputComponent]
})
export class CdDateTimePickerModule {
}
